import { Component } from '@angular/core';
import { AuthorizationResponse } from '../../core/model/authorization/authorization-response.model';

/**
 * Dummy testing post message component.
 */
@Component({
    selector: 'ssf-post-message',
    template: `
         
       <ssf-button btnText="Post Message Accepted" (click)="onClickAccepted()"></ssf-button>
        <ssf-button btnText="Post Message Denied" (click)="onClickDenied()"></ssf-button>
        <ssf-button btnText="Post Message Canceled" (click)="onClickCanceled()"></ssf-button>
    `,
})
export class PostMessageComponent {

    // Send a message to the parent
    sendMessage(type: string) {
        let data: AuthorizationResponse = {
            mep_id: '123456',
            event_name: type
        };

        console.log('window.parent.postMessage: ', JSON.stringify(data));
        // Make sure you are sending a string, and to stringify JSON
        window.parent.postMessage(data, '*');
    };

    onClickAccepted() {
        this.sendMessage('transaction_accepted');
    }

    onClickDenied() {
        this.sendMessage('transaction_denied');
    }

    onClickCanceled() {
        this.sendMessage('transaction_canceled');
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/components/postmessage/post-message.component.ts